import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getEstimates(perPage, page, status) {
        return Axios.get(`${baseURL}billing/estimate`, {
            params: { perPage: perPage, page: page, status: status }
        }).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response;
            }
            return [];
        });
    },
    getEstimate(estimateId, encoded = true, index) {
        return Axios.get(`${baseURL}billing/estimate/${estimateId}`, {
            params: { encoded, index }
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    createEstimate(data) {
        return Axios.post(`${baseURL}billing/estimate`, data).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    },
    updateEstimate(data, estimateId) {
        return Axios.put(`${baseURL}billing/estimate/${estimateId}`, data).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                } else {
                    return null;
                }
            }
        );
    },
    removeEstimate(estimateId) {
        return Axios.post(`${baseURL}billing/estimate/delete`, {
            estimate_id: estimateId
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    },
    printPdf(estimateId, includeDeclined) {
        return Axios.get(`${baseURL}billing/estimate/print/${estimateId}`, {
            params: { include_declined: includeDeclined }
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    },
    duplicateEstimate(data) {
        return Axios.post(`${baseURL}billing/estimate-copy`, data).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    },
    sendEmail(data) {
        return Axios.post(`${baseURL}billing/estimate/send`, data).then(
            response => response.data.response
        );
    },
    approveEstimate(data) {
        return Axios.post(`${baseURL}billing/estimate/approve`, data).then(
            response => response.data.response
        );
    },
    checkLabRadiology(estimateId) {
        return Axios.get(
            `${baseURL}billing/estimate/check-lab-radiology/${estimateId}`
        ).then(res => {
            if (res.data && res.data.response && res.data.response.resource) {
                return res.data.response.resource;
            }
            return false;
        });
    },
    async isNewEstimateEnabled() {
        let res = await Axios.get(
            `${baseURL}account/is-feature-enabled?key=estimate`
        );
        if (res.data?.response?.resource?.is_enabled === 1) {
            return true;
        } else {
            return false;
        }
    },
    insertBulkPatient(data, estimateId) {
        return Axios.post(
            `${baseURL}billing/estimate/insert-bulk-patient/${estimateId}`,
            data
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            } else {
                return null;
            }
        });
    },
    getDeclinedCount(estimateId) {
        return Axios.get(
            `${baseURL}billing/estimate/decline-count/${estimateId}`
        ).then(response => {
            if (response?.data) {
                return response.data.decline_count;
            } else {
                null;
            }
        });
    },
    getEstimateSMSDetail(estimateId, params) {
        return Axios.get(
            `${baseURL}billing/estimate/sms/dialog/${estimateId}`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    sendSMS(params) {
        return Axios.post(`${baseURL}communication/estimate/sms`, params).then(
            response => response.data.response
        );
    }
};
